import React, { useEffect, useState, useRef } from 'react';
import { getOnbehalf } from '../../utils/loginSession';

import Drawer from '../Drawer/Drawer';
import { disableEnableScroll } from '@tw/style-guide/lib/components/utilities/util';
import CloseIcon from './icon/Close.png';
import ChevronIcon from './icon/Chevron.png';

import styles from './switchrecipient.scss';

import SwitchRecipientDetails from '../switchRecipientDetails/switchrecipient';

function SwitchRecipient({ pVariant, showPopup, callBackClose, breakpoint, router }) {
  const styleView = breakpoint !== 'xs' && breakpoint !== 'sm' ? styles.pcView : styles.mobileView;
  const isDesktop = breakpoint !== 'xs' && breakpoint !== 'sm';
  useEffect(() => {
    disableEnableScroll(showPopup);
  }, [showPopup]);

  const [parentOnClose, setParentOnClose] = useState(false);

  const handleCallBackClose = bool => {
    document.body.style.overflow = document.documentElement.style.overflow = 'unset';
    setParentOnClose(false);
    callBackClose(bool);
  };

  const onBackdropClick = () => {
    console.log("Call back");
  }
  const handleScroll = (event) => {
    event.stopPropagation();
  };
  return (
    <Drawer
      variant="temporary"
      anchor="bottom"
      open={showPopup}
      ModalProps={{ onBackdropClick: () => onBackdropClick() }}
    >
      <div className={styles.confirm_container} onScroll={handleScroll}>
        <div className={`${styles.container} ${styleView}`}>
          <div className={`${styles.fixedHeader}  ${styleView}`}>
            {!isDesktop && (
              <img
                className={styles.btnBack}
                src={ChevronIcon}
                onClick={() => {
                  setParentOnClose(true);
                  document.body.style.overflow = document.documentElement.style.overflow = 'unset';
                }}
              />
            )}
            切換訂貨人
            {isDesktop && <img src={CloseIcon} onClick={() => setParentOnClose(true)} />}
          </div>

          <SwitchRecipientDetails
            parentOnClose={parentOnClose}
            showPopup={showPopup}
            callBackClose={bool => handleCallBackClose(bool)}
            pVariant={pVariant}
            breakpoint={breakpoint}
            router={router}
          />
        </div>
      </div>
    </Drawer>
  );
}

export default SwitchRecipient;
